import { createApi } from "@reduxjs/toolkit/query/react";
import { Ticket } from "@shared/models/Ticket";
import { MIN_PAGE_SIZE } from "@shared/constants";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../config";

export const ticketApi = createApi({
  reducerPath: "ticketApi",
  baseQuery: axiosBaseQuery({
    baseUrl: config.baseApiUrl,
  }),
  tagTypes: ["TicketList", "Ticket"],
  endpoints: (builder) => ({
    getTicketList: builder.query<{ total: number; items: Ticket[] }, Record<string, number | string>>({
      query: ({ page = 1, limit = MIN_PAGE_SIZE, order = "priority", direction = "desc" }) => ({
        url: `tickets?page=${page}&limit=${limit}&order=${order}&direction=${direction}`,
      }),
      providesTags: ["TicketList"],
    }),
    getTicket: builder.query<Ticket, Record<string, number>>({
      query: ({ id }) => ({ url: `tickets/${id}` }),
    }),
    updateTicket: builder.mutation<Ticket, Partial<Pick<Ticket, "id" | "notes" | "is_update_completed">>>({
      query: ({ id, ...body }) => ({
        url: `tickets/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["TicketList"],
      onQueryStarted: async ({ id, notes, is_update_completed }, { dispatch, queryFulfilled }) => {
        // Update individual ticket in cache
        const patchResult = dispatch(
          ticketApi.util.updateQueryData("getTicket", { id } as { id: number }, (draft) => {
            if (notes !== undefined) draft.notes = notes;
            if (is_update_completed !== undefined) draft.is_update_completed = is_update_completed;
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const { useGetTicketListQuery, useGetTicketQuery, useUpdateTicketMutation } = ticketApi;
